import { ConsentFormScreen } from "@/interactors/ConsentFormScreen";

export default function ConsentForm() {
  return <ConsentFormScreen />;
}
